import { contactFactory } from '@rtls/core/models/human/contact.factory';
import { addressFactory } from '@rtls/core/models/location/address.factory';
import { Company } from '@rtls/core/models/location/company.model';
import {
	chance,
	nullable,
	randomDate,
	randomName,
	randomNumber,
	randomUuid,
} from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts/lib';

export const companyFactory: any = Factory.makeFactory<Company>({
	id: Factory.each((i) => nullable(i)),
	createdDate: Factory.each(() => nullable(randomDate())),
	updatedDate: Factory.each(() => nullable(randomDate())),
	deletedDate: Factory.each(() => nullable(randomDate(), 3)),
	address: Factory.each(() => nullable(addressFactory.build())),
	contact: contactFactory.build(),
	vat: Factory.each(() => nullable(chance.ssn())),
	registrationNumber: Factory.each(() => nullable(chance.ssn())),
	thingCount: Factory.each(() => nullable(randomNumber())),
	corporateName: Factory.each(() => randomName()),
	uuid: Factory.each(() => randomUuid()),
});
